import { hotPosts } from "@/mocks/gossipData";

export default function FeatureStory() {
  const [lead, ...rest] = hotPosts;
  return (
    <section id="feature" className="w-full bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-semibold tracking-widest">
              <i className="ri-vip-diamond-line"></i> FEATURE STORY
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">深度复盘 · 不只吃瓜</h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            把一段绯闻的来龙去脉、时间线与公关逻辑讲清楚，让你看得不只是热闹，更是门道。
          </p>
        </div>

        {/* 主打 */}
        <article className="group grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch bg-background-50 rounded-lg overflow-hidden border border-background-200 mb-6">
          <a href="#feature" className="relative block overflow-hidden h-64 lg:h-auto aspect-[16/10] lg:aspect-auto" aria-label={lead.title}>
            <img
              src={lead.image}
              alt={lead.alt}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <span className="absolute top-4 left-4 bg-accent-600 text-background-50 text-xs font-medium rounded px-2.5 py-1">主编推荐</span>
          </a>
          <div className="p-5 md:p-8 flex flex-col justify-center">
            <span className="inline-flex items-center gap-1.5 text-xs text-accent-700 mb-3">
              <i className="ri-vip-crown-2-line"></i> 本周深度策划
            </span>
            <h3 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
              <a href="#feature">{lead.title}</a>
            </h3>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{lead.summary}</p>
            <div className="mt-5 flex items-center justify-between text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-eye-line"></i> {lead.meta.split(" · ")[1]}
              </span>
              <span className="inline-flex items-center gap-1.5 text-primary-600">
                继续阅读 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </article>

        {/* 其余，不对称排版 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {rest.map((post, i) => (
            <article
              key={post.id}
              className={`group rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors flex flex-col ${
                i === 0 ? "md:col-span-3 lg:col-span-1" : ""
              }`}
            >
              <a href="#feature" className="relative block overflow-hidden aspect-[16/10]" aria-label={post.title}>
                <img
                  src={post.image}
                  alt={post.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </a>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <span className="inline-flex items-center gap-1.5 text-[11px] text-accent-700 mb-2">
                  <i className="ri-file-text-line"></i> {post.meta.split(" · ")[0]}
                </span>
                <h4 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  <a href="#feature">{post.title}</a>
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{post.summary}</p>
                <div className="mt-auto pt-3 flex items-center justify-between text-xs text-foreground-500 mt-4">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i> {post.meta.split(" · ")[1].replace("阅读 ", "")}
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}